"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewsAPI = void 0;
const base_1 = require("../base");
class ReviewsAPI extends base_1.BaseAPI {
    /**
     * Retrieve the details of a movie or TV show review.
     *
     * @see https://developers.themoviedb.org/3/reviews/get-review-details
     */
    async details(reviewId) {
        const path = this.getPath(`/review/${reviewId}`);
        return this.get(path);
    }
}
exports.ReviewsAPI = ReviewsAPI;
